import axios from 'axios';

const API_URL = '';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('clarix_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('clarix_token');
      localStorage.removeItem('clarix_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
